<template>
    <div v-if="typeRange == 129" class="designeroption" :data-designer-component-id="component_id">
      <h3>
        Colour Range
      </h3>
      <div class="stylesoption">
        <div class="form-group" :class="[!valid_selection ? 'has-error' : '']">
          <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
          </select>
          <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
            <option>Loading Options...</option>
          </select>
        </div>
      </div>
    </div>
    <div v-else class="third-icons">
        <tile-question-layout v-if="panel_required && range_count" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

        </tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionColourRange from "../DesignerQuestionColourRange.vue";

    export default {
        mixins: [
            DesignerQuestionColourRange
        ],
    }
</script>
